import React from "react";
import { FormControl, Select, MenuItem, InputAdornment } from "@mui/material";

const SelectInput = ({ icon, options, defaultValue = "", ...props }) => {
  return (
    <FormControl fullWidth>
      <Select
        defaultValue={defaultValue}
        startAdornment={
          <InputAdornment position="start">{icon && icon}</InputAdornment>
        }
        {...props}
      >
        {options?.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectInput;
